import React, { useEffect, useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { Btn } from "../../AbstractElements";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit, FaEye } from "react-icons/fa";
import {
  useAddSGPI,
  useGetSGPIStatus,
  useSGPILists,
  useUpdateSGPI,
} from "./hooks/useSGPI";
import { useGetOrgUnitsData } from "../Configuration/Grade Master/hooks/useGradeMaster";
import { getBrands } from "../ProductCatalogue/repositories/BrandCampaignRepository";
import { useOnboardingOutletTypesData } from "../Onboarding/hooks/useOnBoard";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { Label, Spinner } from "reactstrap";
import { showToast } from "../../utils/toastUtils";
import SGPIMasterModalContent from "./modalContent/SGPIMasterModalContent";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { COLORS } from "../../constants/colors";

const ImageCell = ({
  mediaId,
  handleViewImage,
}: {
  mediaId?: string;
  handleViewImage?: any;
}) => {
  const [loading, setLoading] = useState(true);

  if (!mediaId) {
    return (
      <div
        style={{
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f0f0f0",
          borderRadius: "4px",
        }}
      >
        No Image
      </div>
    );
  }

  return (
    <div style={{ position: "relative", width: "30px", height: "30px" }}>
      {loading && (
        <Spinner
          color="success"
          style={{
            color: "green",
            width: "1rem",
            height: "1rem",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
      <img
        src={`https://tspc-development.truesales.in/media?id=${mediaId}`}
        alt="Image"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "4px",
          display: "flex",
          cursor: "pointer",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => handleViewImage(mediaId)}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </div>
  );
};

const SGPIMaster = () => {
  const [modalVisiable, setModalVisiable] = React.useState(false);
  const [isModalImageOpen, setIsModalImageOpen] = useState(false);
  const [mediaId, setMediaId] = useState<string | number>("");
  const [selectedBrands, setSelectedBrands] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [formValues, setFormValues] = useState<string | number | boolean | any>(
    {
      name: "",
      code: "",
      orgunit: "",
      brands: "",
      sku: "",
      sgpitypes: "",
      status: "",
      outlettype: "",
      startdate: "",
      enddate: "",
      qty: "",
      isstrategic: null,
      media: "",
    }
  );
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    length: 10,
    search: "",
    OrgUnitId: "",
    brands: "",
    outlettype: "",
  });
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [SGPIId, setSGPIId] = useState<string | number>("");
  const [modalStatus, setModalStatus] = useState<string | number>("");
  const [buttonDisable, setButtonDisable] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
    const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
    const { startPolling, stopPolling } = useExcelPolling();

  const { data: sgpiListsData, isLoading: sgpiListLoading } = useSGPILists({
    params: {
      start: filtersState?.page,
      length: filtersState?.length,
      search: filtersState?.search,
      sortColumn: "SgpiId",
      sortOrder: "DESC",
      OrgUnitId: filtersState?.OrgUnitId,
      BrandId: filtersState?.brands,
      OutlettypeId: filtersState?.outlettype,
    },
    enable: true,
  });

  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });

  const { data: onboardOutletTypesData } = useOnboardingOutletTypesData({
    enable: true,
  });

  const { mutate: addSGPI } = useAddSGPI();
  const { mutate: updateSGPI } = useUpdateSGPI();

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const formattedOrgunitDataFilter = [
    { id: "", label: "All" },
    ...formattedOrgUnitData,
  ];

  const outletTypesOptions = onboardOutletTypesData?.data
    ? Object.entries(onboardOutletTypesData?.data || {}).map((item: any) => ({
        id: item[0],
        label: item[1],
      }))
    : [];

  const formattedOutletDataFilter = [
    { id: "", label: "All" },
    ...outletTypesOptions,
  ];

  useEffect(() => {
    if (modalStatus === "Edit" && selectedRow) {
      setFormValues({
        name: selectedRow?.SgpiName,
        code: selectedRow?.SgpiCode,
        orgunit: selectedRow?.OrgUnitId,
        sku: selectedRow?.MaterialSku,
        qty: selectedRow?.MaxQty,
        sgpitypes: selectedRow?.SgpiType,
        status: selectedRow?.SgpiStatus,
        outlettype: selectedRow?.OutlettypeId,
        startdate: selectedRow?.UseStartDate,
        enddate: selectedRow?.UseEndDate,
        isstrategic: selectedRow?.IsStrategic,
        media:
          selectedRow?.SgpiMedia === 0
            ? "No Media Available"
            : selectedRow?.SgpiMedia,
      });

      if (selectedRow?.BrandId && selectedRow?.BrandName) {
        setSelectedBrands({
          id: selectedRow.BrandId,
          label: selectedRow.BrandName,
        });
      } else {
        setSelectedBrands(null);
      }
    } else if (modalStatus === "View" && selectedRow) {
      setFormValues({
        name: selectedRow?.SgpiName,
        code: selectedRow?.SgpiCode,
        orgunit: selectedRow?.OrgUnitId,
        sku: selectedRow?.MaterialSku,
        qty: selectedRow?.MaxQty,
        sgpitypes: selectedRow?.SgpiType,
        status: selectedRow?.SgpiStatus,
        outlettype: selectedRow?.OutlettypeId,
        startdate: selectedRow?.UseStartDate,
        enddate: selectedRow?.UseEndDate,
        isstrategic: selectedRow?.IsStrategic,
        media:
          selectedRow?.SgpiMedia === 0
            ? "No Media Available"
            : selectedRow?.SgpiMedia,
      });

      if (selectedRow?.BrandId && selectedRow?.BrandName) {
        setSelectedBrands({
          id: selectedRow.BrandId,
          label: selectedRow.BrandName,
        });
      } else {
        setSelectedBrands(null);
      }
    }
  }, [selectedRow]);

  const handleStateClear = () => {
    setFormValues({
      name: "",
      code: "",
      orgunit: "",
      brands: "",
      sku: "",
      sgpitypes: "",
      status: "",
      outlettype: "",
      startdate: "",
      enddate: "",
      qty: "",
      isstrategic: null,
    });

    setSelectedBrands(null);
  };

  const handleClose = () => {
    setModalVisiable(false);
    setModalStatus("");
    setSelectedRow(null);
    handleStateClear();
    setButtonDisable(false);
  };
  const toggleModal = () => {
    setModalVisiable(false);
    setModalStatus("");
    setSelectedRow(null);
    handleStateClear();
    setButtonDisable(false);
  };

  const handleViewImage = (id: string | number) => {
    setMediaId(id);
    setIsModalImageOpen(true);
  };

  const toggleImageModal = () => {
    setIsModalImageOpen(!isModalImageOpen);
    // handleClearStates();
  };

  const handleImageClose = () => {
    setIsModalImageOpen(false);
  };

  const handleEdit = (row: any) => {
    setModalVisiable(!modalVisiable);
    setSelectedRow(row);
    setModalStatus("Edit");
    setSGPIId(row?.SgpiId); // SgpiId
  };

  const handleView = (row: any) => {
    setModalVisiable(!modalVisiable);
    setSelectedRow(row);
    setModalStatus("View");
    setSGPIId(row?.SgpiId);
  };

  const handleAdd = () => {
    setModalVisiable(!modalVisiable);
    setModalStatus("Add");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        length: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => {
      const updatedState = {
        ...prev,
        [key]: selected.id === "null" ? null : Number(selected.id),
      };

      // 👇 Reset Brand filter when OrgUnit changes
      if (key === "OrgUnitId") {
        updatedState.brands = ""; // or null depending on your state structure
      }

      return updatedState;
    });
  };

  const validateForm = (formValues: any) => {
    if (!formValues?.name?.trim()) {
      showToast.warning("Please Fill SGPI Name Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.code?.trim()) {
      showToast.warning("Please Fill SGPI Code Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.sku?.trim()) {
      showToast.warning("Please Fill SKU Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.startdate) {
      showToast.warning("Please Fill Start Date Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.enddate) {
      showToast.warning("Please Fill End Date Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.orgunit) {
      showToast.warning("Please Fill Org Unit Field!");
      setButtonDisable(false);
      return false;
    } else if (!selectedBrands?.id) {
      showToast.warning("Please Fill Brands Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.qty) {
      showToast.warning("Please Fill Quantity Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.sgpitypes) {
      showToast.warning("Please Fill SGPI Types Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.status) {
      showToast.warning("Please Fill Status Field!");
      setButtonDisable(false);
      return false;
    } else if (!formValues?.outlettype) {
      showToast.warning("Please Fill Outlet Types Field!");
      setButtonDisable(false);
      return false;
    }

    const startDate = new Date(formValues.startdate);
    const endDate = new Date(formValues.enddate);

    if (endDate < startDate) {
      showToast.warning("End Date cannot be earlier than Start Date!");
      setButtonDisable(false);
      return false;
    }
    if (startDate > endDate) {
      showToast.warning("Start Date cannot be later than End Date!");
      setButtonDisable(false);
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    const isValid = validateForm(formValues);
    if (!isValid) return;

    const payload = {
      SgpiName: formValues.name,
      SgpiCode: formValues?.code,
      SgpiStatus: formValues?.status,
      SgpiMedia: formValues?.media,
      MaterialSku: formValues?.sku,
      SgpiType: formValues?.sgpitypes,
      UseStartDate: formValues?.startdate,
      UseEndDate: formValues?.enddate,
      OrgUnitId: formValues?.orgunit,
      BrandId: selectedBrands?.id ?? null, // safe fallback
      MaxQty: formValues?.qty,
      OutletTypeId: formValues?.outlettype,
      IsStrategic: formValues?.isstrategic,
    };

    if (modalStatus === "Edit") {
      setButtonDisable(true);
      updateSGPI(
        { id: SGPIId, body: payload },
        {
          onSuccess: handleClose,
          onError: () => {
            setButtonDisable(false);
          },
        }
      );
    } else {
      setButtonDisable(true);
      addSGPI(
        { body: payload },
        {
          onSuccess: handleClose,
          onError: () => {
            setButtonDisable(false);
          },
        }
      );
    }
  };

     const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
  const start= filtersState?.page
      const length= filtersState?.length
      const search= filtersState?.search
      const sortColumn= "SgpiId"
      const sortOrder= "DESC"
     const OrgUnitId= filtersState?.OrgUnitId
     const BrandId= filtersState?.brands
     const OutlettypeId= filtersState?.outlettype

    const params = new URLSearchParams();

    // Append only if the value exists
    if (OrgUnitId) params.append("OrgUnitId", OrgUnitId);
    if (BrandId) params.append("BrandId", BrandId);
    if (OutlettypeId) params.append("OutlettypeId", OutlettypeId);
    if (sortColumn) params.append("sortColumn", sortColumn);
    if (start) params.append("start", start);
    if (length) params.append("length", length);
    if (search) params.append("search", search);
    if (sortOrder) params.append("sortOrder", sortOrder);
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.SGPI.GET_SGPI_LISTS_EXCEL}?${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };

  return (
    <div className="p-2">
      <PageHeader
        title="SGPI Master"
        buttons={[
          {
            label: "+ Add SGPI Master",
            onClick: () => handleAdd(),
            color: "#2e8dd3",
          },
          {
                     label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                      onClick:downloadExcelGet,
                    color: loadingExcel ? COLORS.disable : COLORS.primary,
                                disable: loadingExcel ? true : false,
                     },
        ]}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          marginTop: "2%",
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <BasicDataTable
            search={true}
            Title="SGPI Category"
            columns={dummyData(handleEdit, handleViewImage, handleView)}
            dynamicHeightOnRowsPerPage={true}
            data={sgpiListsData?.data || []}
            showSpinner={sgpiListLoading}
            SearchPlaceholder="Search by SGPI Name, SGPI Type"
            headerContent={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "15px",
                }}
              >
                <div style={{ marginLeft: "10px" }}>
                  <RoundedDropdown
                    options={formattedOrgunitDataFilter || []}
                    onSelect={(e) => handleFilter("OrgUnitId", e)}
                    defaultLabel="All"
                    width="120px"
                    isShowHeading
                    DropdownHeading="Org Unit"
                    headingColor="#2e8dd3"
                  />
                </div>

                {/* Brand Dropdown */}
                <div style={{ marginLeft: "10px" }}>
                  <CustomDropdown
                    key={filtersState?.OrgUnitId}
                    placeholder="All"
                    DropdownLabel="Brands"
                    value={filtersState?.brands}
                    onChange={(id) => {
                      setFiltersState((prev: any) => ({
                        ...prev,
                        brands: id,
                        page: 1,
                      }));
                    }}
                    fetchData={async ({ page, limit, search }) => {
                      const res = await getBrands({
                        page,
                        limit,
                        search,
                        Orgunitid: filtersState?.OrgUnitId,
                      });

                      const rawData = res?.data?.data || [];
                      let formatted = rawData.map((item: any) => ({
                        id: item.BrandId,
                        label: item.BrandName,
                      }));

                      if (page === 1) {
                        formatted = [{ id: "", label: "All" }, ...formatted];
                      }

                      const hasMore = rawData.length === limit;

                      return {
                        data: formatted,
                        hasMore,
                      };
                    }}
                    includeAllOption
                  />
                </div>
                {/* OutletType Dropdown */}

                <div style={{ marginLeft: "10px" }}>
                  <RoundedDropdown
                    options={formattedOutletDataFilter || []}
                    onSelect={(e) => handleFilter("outlettype", e)}
                    defaultLabel="All"
                    width="120px"
                    isShowHeading
                    DropdownHeading="Outlet Type"
                    headingColor="#2e8dd3"
                  />
                </div>
              </div>
            }
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            handleSearch={(val: any) => {
              handleSearch(val);
            }}
            paginationTotalRows={sgpiListsData?.recordsTotal}
          />
        </div>
      </div>

      {modalVisiable && (
        <RouteModal
          isOpen={modalVisiable}
          toggle={toggleModal}
          title={
            modalStatus === "Edit" ? "Edit SGPI Master" : "Add SGPI Master"
          }
          size="lg"
          content={
            <SGPIMasterModalContent
              setFormValues={setFormValues}
              formValues={formValues}
              handleSubmit={handleSubmit}
              handleClose={handleClose}
              setSelectedBrands={setSelectedBrands}
              selectedBrands={selectedBrands}
              modalStatus={modalStatus}
            />
          }
        />
      )}

      <RouteModal
        isOpen={isModalImageOpen}
        toggle={toggleImageModal}
        title="View Media"
        size="xl"
        content={
          <div style={{ textAlign: "center" }}>
            <div style={{ width: "100%" }}>
              {mediaId ? (
                <img
                  src={`https://tspc-development.truesales.in/media?id=${mediaId}`}
                  alt="Selected"
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                "No image selected"
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "start" }}>
              <Btn
                style={{
                  backgroundColor: "#43bab2",
                  color: "#F9FAFC",
                  border: "1px solid #43bab2",
                  marginTop: "10px",
                  width: "20%",
                }}
                type="button"
                onClick={handleImageClose}
              >
                Close
              </Btn>
            </div>
          </div>
        }
      />
    </div>
  );
};
export default SGPIMaster;

const dummyData = (
  handleEdit: (row: any) => void,
  handleViewImage: (row: any) => void,
  handleView: (row: any) => void
) => [
  {
    name: "Image",
    cell: (row: any) => (
      <ImageCell mediaId={row?.SgpiMedia} handleViewImage={handleViewImage} />
    ),
  },
  {
    name: "Org Unit Name",
    selector: (row: { UnitName: string }) => row?.UnitName || "-",
    minWidth: "170px",
    sortable: true,
  },
  {
    name: " SGPI Name",
    selector: (row: { SgpiName: string }) => row.SgpiName || "-",
    wrap: true,
    minWidth: "150px",
    sortable: true,
  },
  {
    name: "SGPI Type",
    selector: (row: { SgpiType: string }) => row.SgpiType || "-",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Status",
    selector: (row: { SgpiStatus: string }) => row.SgpiStatus || "-",
    minWidth: "150px",
    wrap: true,
    sortable: true,
  },

  {
    name: "Use Start Date",
    selector: (row: { UseStartDate: string }) => row.UseStartDate || "-",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Use End Date",
    selector: (row: { UseEndDate: string }) => row.UseEndDate || "-",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Brand",
    selector: (row: { BrandName: string }) => row?.BrandName || "-",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Outlet Type",
    selector: (row: { OutlettypeName: string }) => row?.OutlettypeName || "-",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Is Strategic",
    selector: (row: { IsStrategic: string }) =>
      row.IsStrategic
        ? row.IsStrategic.toString() === "true"
          ? "Yes"
          : "No"
        : "-",
    minWidth: "150px",
    sortable: true,
  },

  {
    name: "Actions",
    cell: (row: any) => (
      <div style={{ gap: "2px", display: "flex", flexDirection: "row" }}>
        <button
          onClick={() => handleEdit(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            fontSize: "14px",
          }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
        <button
          onClick={() => handleView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            fontSize: "14px",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];
